import type { ENV } from '@sbt-web/utils';

// Google Tag Manager
export const GTM_URL = 'https://www.googletagmanager.com/gtm.js?id=GTM-TWPJW6H';
export const GTM_URL_CORE_VITALS_CHECK =
  'https://www.googletagmanager.com/gtm.js?id=GTM-NGB5VQNB';

// Network
export const HADES_PATH = '/hades';
export const WEB_API_CHANNEL = 'web';
export const MOBILE_API_CHANNEL = 'msite';

// Anubi
export const ADS_PER_PAGE = 30;
export const DEFAULT_GALLERY_ITEMS_POS = 5;
export const LISTING_PAGE_LIMIT = 300;

export const houstonEnvMap = new Map<ENV, 'dev' | 'pre' | 'pro'>([
  ['dev', 'pre'],
  ['stage', 'pre'],
  ['prod', 'pro'],
]);

export const DEFAULT_ADVERTISER_NAME = 'Utente';

//Share:
export const AD_SHARING_TITLE =
  'Questo annuncio su Subito potrebbe interessarti: ';

export const PROFILE_ADS_PER_PAGE = 24;
export const DEFAULT_USER_NAME = 'Utente';

export const LABEL_REQUESTID = 'X-Subito-Req-Id';

export const HERE_MAPS_BASE_URL = 'https://geocode.search.hereapi.com';

export const TRUST_DEMERGE_SERVER_TOGGLE =
  'it.subito.web.trust.demerge.killswitch-rollout';
export const TRUST_DEMERGE_ROLLOUT_TOGGLE =
  'it.subito.web.trust.demerge.final-rollout';
